module.exports = alg => `sha${alg.substr(2, 3)}`
